import {MessageBase} from './MessageBase';

/**
 * Base class for messages which are broadcasted.
 */
export abstract class BroadcastMessage extends MessageBase {
  // NOP
}
